// extracted by mini-css-extract-plugin
export default {"addWorkLeave":"WorkLeave_addWorkLeave__U6QZn","customFileUpload":"WorkLeave_customFileUpload__rzXCH"};